import { type FC } from 'react';
import type { FormControlProps } from './types';
import { FormControl as ChakraUiFormControl } from '@chakra-ui/react';

export const FormControl: FC<FormControlProps> = ({ children, ...props }) => {
  return (
    <ChakraUiFormControl
      variant="floating"
      position="relative"
      {...props}
    >
      {children}
    </ChakraUiFormControl>
  )
}
